/**
 * @generated SignedSource<<223fec6083ccfdbe88cb5cae56d9429c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeroCarouselRequestMore_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
  readonly " $fragmentType": "HeroCarouselRequestMore_item";
};
export type HeroCarouselRequestMore_item$key = {
  readonly " $data"?: HeroCarouselRequestMore_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselRequestMore_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroCarouselRequestMore_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "59004f5ae8d56063aef81aaf2163d54f";

export default node;
